import { Routes } from '@angular/router';

import { SbRootComponent } from '@valk-nx/storyblok/components/root/src/lib/root.component';
import { UrlCleanupGuard } from '@valk-nx/url-cleanup-guard/lib/url-cleanup.guard';

export const routes: Routes = [
	{
		path: '**',
		component: SbRootComponent,
		canActivate: [UrlCleanupGuard],
	},
];
